export const isIntroTextEmptyValue = (text) =>
  !text ||
  text === "<p></p>" ||
  text === "<p><br></p>" ||
  text === "<p><br/></p>";

export const normalizeIntroHtml = (text) =>
  text ? text.replace(/<([a-zA-Z0-9]+)>\s*<\/\1>\s*/g, "") : "";

const INTRO_DOM_ALLOWED_TAGS = new Set([
  "input", "span", "button", "select", "option", "strong", "u", "i", "em", "a",
  "br", "p", "div", "li", "ol", "ul", "blockquote", "style",
]);

const URL_BEARING_ATTRS = new Set(["href", "action", "formaction", "xlink:href"]);

const canonicalizeUrlForSafetyCheck = (value) => {
  if (typeof value !== "string") return "";
  // Strip whitespace/control chars that can hide unsafe schemes (e.g. java\tScript:).
  return value.replace(/[\u0000-\u001F\u007F\s]+/g, "").toLowerCase();
};

const UNSAFE_URL_PATTERN = /^(javascript|vbscript|data:text\/html)/i;

const isUnsafeUrlValue = (value) => {
  if (value === null || value === undefined || value === "") return false;
  return UNSAFE_URL_PATTERN.test(canonicalizeUrlForSafetyCheck(String(value)));
};

export const isIntroHtmlEquivalent = (a, b) => {
  if (isIntroTextEmptyValue(a) && isIntroTextEmptyValue(b)) return true;
  const norm = (html) => (html ?? "").replace(/\s+/g, " ").trim();
  return norm(a) === norm(b);
};

export const sanitizeIntroHtmlForDom = (html) => {
  if (!html || isIntroTextEmptyValue(html)) return "<p></p>";
  try {
    const container = document.createElement("div");
    container.innerHTML = html;
    container.querySelectorAll("script, iframe, object, embed, link, meta").forEach((el) => el.remove());
    container.querySelectorAll("*").forEach((el) => {
      if (!INTRO_DOM_ALLOWED_TAGS.has(el.tagName.toLowerCase())) {
        el.replaceWith(...el.childNodes);
        return;
      }
      [...el.attributes].forEach((attr) => {
        const attrName = attr.name.toLowerCase();
        if (/^on/i.test(attrName) || attrName === "srcdoc") {
          el.removeAttribute(attr.name);
          return;
        }
        if (URL_BEARING_ATTRS.has(attrName) && isUnsafeUrlValue(attr.value)) {
          el.removeAttribute(attr.name);
        }
      });
    });
    return container.innerHTML;
  } catch (_) {
    return "<p></p>";
  }
};

export const resolveIntroDisplayHtml = (incoming) => {
  const raw = incoming ?? "";
  const isEmpty =
    !raw ||
    raw === "" ||
    isIntroTextEmptyValue(raw);
  return isEmpty ? "<p></p>" : sanitizeIntroHtmlForDom(raw);
};
